module.exports = "/images/vendor/flag-icon-css/flags/1x1/al.svg?46612c2737ddd5ca906721aeb63aa7c0";